import './table.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import isNull from 'lodash/isNull';
import filter from 'lodash/filter';
import find from 'lodash/find';
import noop from  'lodash/noop';
import minBy from 'lodash/minBy';
import maxBy from 'lodash/maxBy';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import qs from 'qs';
import cn from 'classname';
import PaginationButton from './paginationButton';

import {enum as offerStatuses} from '../../../../../../../enums/offer-statuses';

import CustomizableBlock from '../../../shared/customizable-block';
import { formatMoney } from '../../../shared/format';
import { getCurrencyIcon } from '../../../../../../shared/js/get-currency-icon';

import dashboard from '../../../../config/dashboard';
import DomainsList from '../../../programs/components/table/domains-list';
import DomainsCount from '../../../programs/components/table/domains-count';

const isRocket = true;
const isEverad = process.env.CPA_ENV === 'everad';

const Table = ({
	table,
	intl,
	sortByColumn,
	payoutCurrencies,
	remove,
	can,
	fetchMore,
	lists,
	toggleSwitchToOrder,
	toggleRow,
	toggleHoverOnRow,
	toggleOffersView,
	isSortedByVolume,
	sortByVolume,
	allOffersCollapsed
}) => (
	<div className="table-container">
		<table className="simple-table offers-table">
			<thead className="simple-table__head font-roboto-medium">
				<tr>
					{ getSortedTh({
						header: table.headers.id,
						table,
						sortByColumn,
						intl
					}) }

					{ getSortedTh({
						header: table.headers.title,
						table,
						sortByColumn,
						intl,
						renderCustom: (
							<span>
								{!isRocket && (
									<p className="order-action-btn order-action-btn--reorder" onClick={e => {
										e.stopPropagation();
										toggleSwitchToOrder();
									}}>
										<span>{intl('Reorder')}</span>
									</p>
								)}
								<CustomizableBlock
									className='offers-table__inline'
									isHintAllowed={false}
									settingId='offers-full-info-button'
								>
									<p className={cn(
										'order-action-btn',
										'order-action-btn--reorder',
										'full-info-btn',
										!allOffersCollapsed && 'active-btn'
									)} onClick={e => {
										e.stopPropagation();
										toggleOffersView();
									}}>
										<span>{intl('Full info')}</span>
									</p>
								</CustomizableBlock>
								{!isRocket && (
									<p
										className={cn('order-action-btn order-action-btn--reorder width-auto', {
											['active-btn']: isSortedByVolume
										})}
										onClick={(e) => {
											e.stopPropagation();
											sortByVolume();
										}}
									>
										<span>{intl('By volume')}</span>
									</p>
								)}
							</span>
						)
					}) }

					{isRocket && getSortedTh({
						header: table.headers[isEverad ? 'category' : 'category_rp'],
						table,
						sortByColumn,
						intl
					})}
					{isRocket && getSortedTh({
						header: table.headers.sale_model,
						table,
						sortByColumn,
						intl
					})}
					{isRocket && (
						<th>{intl('Price')}</th>
					)}

					{getSortedTh({
						header: table.headers.geo,
						table,
						sortByColumn,
						intl
					})}
					{isRocket && (
						<th className="mid-col">
							{intl('CC CAP')}
						</th>
					)}
					{isRocket && getSortedTh({
						header: table.headers.product_cap,
						table,
						sortByColumn,
						intl
					})}
					{getSortedTh({
						header: table.headers.available_quantity,
						table,
						sortByColumn,
						intl
					})}
					{getSortedTh({
						header: table.headers.remaining_quantity_in_days,
						table,
						sortByColumn,
						intl
					})}
					{isEverad && getSortedTh({
						header: table.headers.leads_cap,
						table,
						sortByColumn,
						intl
					})}
					{!isRocket && <th className="link">{intl('Links')}</th>}
					{
						!isRocket &&
						<th className="tags">{intl('Tags')}</th>
					}
					<CustomizableBlock className="language" tag='th' settingId='offers-lang-column' isHidden={isEverad}>
						{intl('Lang')}
					</CustomizableBlock>
					<th />
				</tr>
			</thead>

			<tbody className="simple-table__body">
				{ table.rows.map(row => (
					<tr key={row.id} className={cn(!row.collapsed && 'row-opened')}>
						<td className="id">{row.id}</td>
						<td className="title"
							onMouseEnter={toggleHoverOnRow.bind(null, row.id)}
							onMouseLeave={toggleHoverOnRow.bind(null, row.id)}
						>
							<span className="title__img">
								<img src={row.image || '//placehold.it/40x40'} alt="offer img"/>
							</span>
							{row.comment && (
								<div className='title__comment'>
									{row.comment}
								</div>
							)}
							<span className="title__text">
								{row.title}{' '}
								<span>({row.removed_at ? 'removed' : getOfferStatus(row)})</span>
							</span>
							{(!isRocket || row.geo.length !== 1 || (isEverad && !!get(row, 'domains.length'))) && (
								<span
									className={cn(
										'title__expand',
										!row.collapsed && 'title__expand--opened'
									)}
									onClick={() => toggleRow(row.id)}
								>
									{ !row.collapsed ? 'Close' : 'Open' }
								</span>
							)}
							{

								!row.collapsed && isEverad && can('offers_list_removed') && !!row.domains &&
								<DomainsList row={row} offer_id={row.id}/>
							}
							{
								can('offers_list_removed') && isEverad && !!row.domains && row.is_hovered &&
								<DomainsCount row={row} offer_id={row.id}/>
							}

						</td>
						{isRocket && (
							<td className="padding-col">{isEverad ? row.category : row.category_rp}</td>
						)}
						{isRocket && (
							<td className="padding-col">{find(lists['offer-sale-models'], { id: row.sale_model }).text}</td>
						)}
						{isRocket && (
							<td className="geos-currenies">
								{row.geo.length === 1 && (
									<span>
										{row.geo[0].price} {getCurrencyIcon(row.geo[0].currency)}
									</span>
								)}
								{!row.collapsed && row.geo.length > 1 && row.geo.map((location) => (
									<div className='geos-currenies-row' key={location.country_code}>
										{location.price} {getCurrencyIcon(location.currency)}
									</div>
								))}
							</td>
						)}

						{!row.collapsed ?
							<td className="geos-currenies">
								{ row.geo.length ? row.geo.map(location => (
									<div className="geos-currenies-row" key={location.id} >
										<div className="geo-country">
											<span
												className={`geo-country__flag flag-icon flag-icon-${location.country_code.toLowerCase()}`}
											/>
											<span className="geo-country__name">{getCountryName(location)}</span>
										</div>
										{!isRocket && payoutCurrencies.map((currency, index) =>
											<div className="currency__amount first" key={index}>
												<div className='average'>
													{location[`avg_rate_${currency}`] ? location[`avg_rate_${currency}`] + ` ${currency}` : ''}
												</div>
												<div className='prices'>
													{location[`payout_${currency}`] ? location[`payout_${currency}`] + ` ${currency}` : ''}
												</div>
											</div>
										)}
									</div>
								)) : <div className="geos-currenies-row">
									<div className="geo-country">-</div>
									{!isRocket && <div className="currency__amount first">-</div>}
									{!isRocket && <div className="currency__amount">-</div>}
								</div> }

							</td> :
							<td className="geos-currenies">
								<div className="geo-country">
									<div className="geos-currenies-row">
										<div className="geo-country">
											{isRocket && row.geo && row.geo.length === 1 && (
												<span
													className={`geo-country__flag flag-icon flag-icon-${row.geo[0].country_code.toLowerCase()}`}
												/>
											)}
											{isRocket && row.geo && row.geo.length === 1 && (
												<span className="geo-country__name">
													{getCountryName(row.geo[0])}
												</span>
											)}

											{row.geo && (!isRocket || row.geo.length > 1) && (
												<span className="geo-country__name">
													{row.geo.length || '-'}
												</span>
											)}

											{row.geo && row.geo.length > 0 && (
												<GeoList geos={row.geo} />
											)}
										</div>
										{!isRocket && payoutCurrencies.map(curr => getGeos(row, `payout_${curr}`, ''))}
									</div>
								</div>
							</td>
						}
						{isRocket && (
							<td className="geos-currenies">
								{row.geo.length === 1 && (
									<span>
										{row.geo[0].cc_cap} {row.geo[0].cc_cap_percent && `(${row.geo[0].cc_cap_percent}%)`}
									</span>
								)}
								{!row.collapsed && row.geo.length > 1 && row.geo.map((location) => (
									<div className='geos-currenies-row' key={location.country_code}>
										{location.cc_cap} {location.cc_cap_percent && `(${location.cc_cap_percent}%)`}
									</div>
								))}
							</td>
						)}
						{isRocket && (
							<td>
								{!isNull(row.product_cap) ? ((row.product_cap >= 0 ? '+' : '−') + Math.abs(row.product_cap)) : '−'}
							</td>
						)}
						<td>
							<span>
								{!isNull(row.available_quantity) ? row.available_quantity : '?'}
							</span>
						</td>
						<td>
							<span className={row.remaining_quantity_in_days <= row.product_production_cycle && 'color-red'}>
								{!isNull(row.remaining_quantity_in_days) ? Math.round(row.remaining_quantity_in_days) : '?'}
							</span>
						</td>
						{
							isEverad &&
							<td>
								<span>
									{!isNull(row.leads_cap) ? Math.round(row.leads_cap) : '?'}
								</span>
							</td>
						}
						{!isRocket && (!row.collapsed ?
							<td className="link">
								{ row.domains && row.domains.length && filter(row.domains, { type: 'landing' }).map(domain => (
									<a
										key={domain.id}
										className="link__landing"
										href={`http://${domain.domain}`}
										target="_blank"
									>
										{domain.domain}
									</a>
								)) }
								{ row.domains && row.domains.length && filter(row.domains, { type: 'transit' }).map(domain => (
									<a
										key={domain.id}
										className="link__transit"
										href={`http://${domain.domain}`}
										target="_blank"
									>
										{domain.domain}
									</a>
								)) }
								{(!row.domains || !row.domains.length) && '-'}
							</td> :
							<td className="link">
								<div className="links">
									{row.domains && row.domains.length && filter(row.domains, { type: 'landing' }) &&
									filter(row.domains, { type: 'landing' }).length &&
									<a className="link-collapsed" href={`http://${getTopLanding(row)}`} target="_blank">
										{getTopLanding(row) || '-'}
									</a> || '-'}
									<span>{row.domains && row.domains.length}</span>
								</div>
							</td>
						)}
						{
							!isRocket &&
							<td className="tags"> {row.tags && row.tags.length ? row.tags.join(',') : '-'} </td>
						}

						{!row.collapsed ?
							<CustomizableBlock
								className="language"
								tag='td'
								settingId='offers-lang-column'
								isHintAllowed={false}
								isHidden={isEverad}
							>
								{ row.languages && row.languages.length ? row.languages.map(lang => (
									<div key={lang}>{find(lists['landing-languages'], { id: lang }).text} </div>
								)) : '-'}
							</CustomizableBlock>
							:
							<CustomizableBlock
								className="language"
								tag='td'
								settingId='offers-lang-column'
								isHintAllowed={false}
								isHidden={isEverad}
							>
								<div>{row.languages && row.languages.length > 0 ? row.languages.length : '-'}</div>
								{row.languages && row.languages.length > 0 && <div className="segments-popup">
									{ row.languages.map(lang => (
										<div key={lang}>{find(lists['landing-languages'], { id: lang }).text} </div>
									)) }
								</div>}
							</CustomizableBlock>
						}

						<td className="actions">
							{
								!row.removed_at &&
								<a
									className="action_copy"
									title='Copy'
									href="#"
									onClick={(e) => {
										e.preventDefault();
										navigator.clipboard.writeText(`${dashboard.baseURL}/offers/${row.id}`);
									}}
								/>
							}
							{
								!row.removed_at &&
								<Link className="action_info" to={`/programs/info/${row.id}`}/>
							}
							{
								!row.removed_at &&
								<Link className="action_edit" to={`/programs/editor/${row.id}`}/>
							}
							{
								!row.removed_at &&
								<Link className="action_statistics" target="_blank" to={buildStatisticsLink(row)}/>
							}
							{can('edit') && !row.removed_at && (
								<a
									href="#"
									onClick={e => {
										e.preventDefault();
										confirm(`${intl('Remove offer')} ${row.title}?`) && remove(row.id );
									}} className="action_delete" />
							)}
						</td>
					</tr>
				)) }
			</tbody>
		</table>
		{table.totalRows < get(table.rows, '[0].total_count', 0) && (
			<div className="table-container__navigation">
				<PaginationButton intl={intl} fetchMore={fetchMore} />
			</div>
		)}
	</div>
);

Table.propTypes = {
	table: PropTypes.object,
	intl: PropTypes.func,
	sortByColumn: PropTypes.func,
	showMoreRows: PropTypes.func,
	remove: PropTypes.func,
	can: PropTypes.func,
	toggleSwitchToOrder: PropTypes.func,
	lists: PropTypes.object,
	toggleRow: PropTypes.func,
	toggleOffersView: PropTypes.func,
	allOffersCollapsed: PropTypes.bool
};

function buildStatisticsLink (offer) {
	const query = { filters: { offers: [offer.id] }};

	const entity = {
		filters: [{
			name: 'offers',
			values: [{ value: offer.id, label: offer.title }]
		}]
	};

	return `/statistics?${qs.stringify({query, entity})}`;
}

function getSortedTh(options) {
	const { header, table, sortByColumn, intl, renderCustom = null } = options;
	return (
		<th
			className={cn({
				'sort-header': header.direction,
				'show-sort-sign-after-title': renderCustom,
				active: table.sortedColumn.index === header.index,
				[header.className]: header.className,
				[table.sortedColumn.direction]:
				table.sortedColumn.index === header.index && table.sortedColumn.direction
			})}
			onClick={() => (header.direction ? sortByColumn(header.index) : noop)}
		>
			<span className="th-title">{intl(header.title)}</span>
			{ renderCustom }
		</th>
	);
}

const minPayout = (row, payoutCurrency) => {
	return minBy(row.geo, payoutCurrency) && minBy(row.geo, payoutCurrency)[payoutCurrency] || '';
};

const maxPayout = (row, payoutCurrency) => {
	return maxBy(row.geo, payoutCurrency) && maxBy(row.geo, payoutCurrency)[payoutCurrency] || '';
};

const avgPayoutsByCurrency = (row, payoutCurrency) => {
	const payouts = row.base_payouts || [];
	return payouts.filter(item => item.currency === payoutCurrency.split('_')[1])
		.map(item => get(item, ['avg_rate'], 0));
};

const findAverage = rates => {
	const filteredRates = rates.filter(Number);
	return Math.round(filteredRates.reduce((acc, rate) => acc + rate, 0) / filteredRates.length);
};

const getGeos = (row, payoutCurrency, currSymbol) => {
	const avgRates = avgPayoutsByCurrency(row, payoutCurrency);
	const offerAvgRate = isEmpty(avgRates) ? '' : findAverage(avgRates);

	return minPayout(row, payoutCurrency) != maxPayout(row, payoutCurrency) ?
		<div className={`currency__amount ${currSymbol === '$' ? 'first' : '-'}`} key={payoutCurrency}>
			<div className='average'>
				{offerAvgRate ? <i>{formatMoney(offerAvgRate) + ' ' + currSymbol}</i> : ''}
			</div>
			<div className='prices'>
				{formatMoney(minPayout(row, payoutCurrency)) || '-'}
				{'—'}
				{formatMoney(maxPayout(row, payoutCurrency)) || '-'}
				{maxPayout(row, payoutCurrency) && <i>{' ' + currSymbol}</i>}
			</div>
		</div> :
		<div className={`currency__amount ${currSymbol === '$' ? 'first' : '-'}`} key={payoutCurrency}>
			<div className='average'>
				{offerAvgRate ? <i>{formatMoney(offerAvgRate) + ' ' + currSymbol}</i> : ''}
			</div>
			<div className='prices'>
				{formatMoney(maxPayout(row, payoutCurrency)) || '-'}
				{maxPayout(row, payoutCurrency) && <i>{' ' + currSymbol}</i>}
			</div>
		</div>;
};

const getTopLanding = row => {
	const landings = filter(row.domains, { type: 'landing' });
	if (!landings || !landings.length) return;
	return maxBy(landings, 'display_priority').domain;
};

const getCountryName = location => {
	const { name, country_code } = location;
	if (name.length >= 14) return country_code;
	return name;
};

const getOfferStatus = row => {
	const { status } = row;
	switch (status) {
		case offerStatuses.active :
			return 'active';
		case offerStatuses.stopped:
			return 'stopped';
		case offerStatuses.hidden:
			return 'hidden';
		default:
			return status;
	}
};

const GeoList = ({ geos }) => (
	<div className="segments-popup">
		<table className='geos-table'>
			<tbody>
				{geos.map((location) => (
					<tr key={location.id}>
						<td>
							<span	className={`geo-country__flag flag-icon flag-icon-${location.country_code.toLowerCase()}`} />
						</td>
						<td>
							<span className='geo-country__name'>
								{getCountryName(location)}
							</span>
						</td>
						{isRocket && (
							<td>
								<span>{location.price} {getCurrencyIcon(location.currency)}</span>
							</td>
						)}
					</tr>
				))}
			</tbody>
		</table>
	</div>
);

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/table/table.js